import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { AttachmentsDrawer } from '@user/components/Attachments/AddAttachmentsDrawer'

type Props = {
  entityType: ENTITY_TYPES
  canUpdate: boolean
  attachmentsOpen: boolean
  onCloseAttachments: () => void
  entityId: number
}

export function EntityAttachmentsDrawer(props: Props) {
  const {
    entityType,
    entityId,
    canUpdate,
    attachmentsOpen: open,
    onCloseAttachments: onClose,
  } = props

  return (
    <AttachmentsDrawer
      entityType={entityType}
      entityId={entityId}
      canUpdate={canUpdate}
      open={open}
      onClose={onClose}
    />
  )
}
